import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';
import {getParam} from '../utils/utils';
import {formatText, truncate} from '../utils/utils';

import Buffering from "../components/Buffering"; 
import Rendition from '../components/Rendition';


import dsd from "../classes/clsDSD";

import D3Graphviz from "../components/D3Graphviz";
import ViewEnumeration from "../components/ViewEnumeration";
import ViewDataDictionary from "../components/ViewDataDictionary";
import ViewMetadata from "../components/ViewMetadata";

import SelectStructure from "../components/SelectStructure";

import {getDataDictionary, getEnumeration, addEnumerationToDataDictionary, editEnumeration} from "../utils/utilsDataDictionary";

import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

import { Plus, Trash, ArrowUp, ArrowDown } from 'react-bootstrap-icons';


class Enumeration extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: null,
            toggle:0
        };


        this.data = {};

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);


        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/`;

    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadDataDictionary(id){

        let StateChange = {};
        StateChange.DataDictionary = null;

        const onLoad = function(data){
            let StateChange = {};
            StateChange.DataDictionary = data;
            StateChange.renderState = "loaded";
            this.setState(StateChange);
            return;
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.DataDictionary = null;
            StateChange.renderState = "failed";

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        if (id){
            StateChange.renderState = "loading";
            getDataDictionary(this.dsd, id,onLoad, onFail);
        }

        this.setState(StateChange);

        return;        
    };

    loadEnumeration(id){

        let StateChange = {};
        StateChange.Enumeration = null;

        const onLoad = function(data){
            let StateChange = {};
            StateChange.Enumeration = data;

            StateChange.FormData = data;

            if (data.DataDictionary){
                StateChange.DataDictionary = data.DataDictionary;
                if (this.context.hasLayout){
                    this.context.Layout.setLeftAsDataDictionary(data.DataDictionary._id);
                }
            }

            StateChange.renderState = "loaded";

            StateChange.OfferEdit = false;
            try{
                if (this.dsd.loggedon){
                    if (StateChange.Enumeration.DataDictionary.idUser == this.dsd.user.id){
                        StateChange.OfferEdit = true;
                    }
                }
            }
            catch{

            }   

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied"
                        StateChange.errorMessage = "You cannot add or edit this Enumeration"
                    break;
                }
            }

            this.setState(StateChange);
            return;
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.Enumeration = null;
            StateChange.renderState = "failed";

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        if (id){
            StateChange.renderState = "loading";
            getEnumeration(this.dsd, id,onLoad, onFail);
        }

        this.setState(StateChange);

        return;
        
    };



    setup(){

        let StateChange = {

            mode: "view",

            idEnumeration: null,
            idDataDictionary: null,

            DataDictionary: null,

            Enumeration: null,

            isUpdated: false,

            isFailed: false,
            errorMessage: null,

            renderState: null,

            FormData: {
                status:'in use'
            },

            OfferEdit:false,
            fallbackpath: null,

            Controls: {
            },

            vizNodeId: null

        }

        if (this.props.location.state){
            if (this.props.location.state.fallbackpath){
                StateChange.fallbackpath = this.props.location.state.fallbackpath;
            }
        }

        if (getParam('mode', this.props)){
            StateChange.mode = getParam('mode', this.props);
        }
        StateChange.idEnumeration = getParam('id', this.props);
        StateChange.idDataDictionary = getParam('idDataDictionary', this.props);

        switch (StateChange.mode){
            case 'new':
                if (!StateChange.idDataDictionary){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Data Dictionary not specified when adding a Enumeration"
                }
                break;
            default:
                if (StateChange.idDataDictionary){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Data Dictionary should not be specified for an existing Enumeration"
                }
                if (!StateChange.idEnumeration){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Enumeration not be specified for an existing Enumeration"
                }
                break;
        }

        if (StateChange.idDataDictionary){
            this.loadDataDictionary(StateChange.idDataDictionary);
        }
        if (StateChange.idEnumeration){
            this.loadEnumeration(StateChange.idEnumeration);
        }

        if (StateChange.mode == "new"){
            if (StateChange.idDataDictionary){
                this.FallBackNavigation = `/datadictionary/${StateChange.idDataDictionary}`;
            }        
        }

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        this.setState(StateChange);
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;        
                this.setState({"FormData": FormData});
                break;                
        }
        return;

    };
    
    handleSubmit(event) {

        const onAdd = (idEnumeration) => {
            this.props.navigation(`/enumeration/${idEnumeration}`);
        };

        const onUpdate = () => {
            this.props.navigation(`/enumeration/${this.state.idEnumeration}`);
        };

        const onError = (error) => {
            this.setState({
                renderState: "error",
                errorMessage: error.errorMessage,
                isError: true
            });
        };

        window.scrollTo(0, 0);
        switch (event.target.name){
            
            case 'btnCancel':

                switch (this.state.mode){
                    case "edit":
                        this.props.navigation(`/enumeration/${this.state.idEnumeration}`);
                        break;
                    case "new":
                        if (this.state.fallbackpath){
                            this.props.navigation(`${this.state.fallbackpath}`);
                        }
                        break;
                }
                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false,
                    renderState: "updating"
                })
        
                switch (this.state.mode){
                    case 'new':
                        addEnumerationToDataDictionary(this.dsd, this.state.idDataDictionary,this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        editEnumeration(this.dsd, this.state.idEnumeration,this.state.FormData, onUpdate, onError);
                        break;
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
        }

        this.setState(StateChange);

        event.preventDefault();
    };




    handleVizClick(event) {

        let StateChange = {};

        let idNode = null;
        if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }
        
        event.preventDefault();

    };


    visualise(){
    
        if (!this.state.Enumeration){
            return null;
        }



        try {

            return(
                <div>
                    <div name="divViz" onClick={this.handleVizClick}>
                        <D3Graphviz dot={this.viz.dot}/>
                    </div>

                </div>
            );
          } catch (error) {
            return <div/>
          }
    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
    
        }


        switch (this.state.mode){
            case 'new':
            case 'edit':

                switch (this.state.renderState){
                    case "loaded":
                    case "updating":
                    case "error":
                        return (
                            <div>

                                <PD.Heading>{this.state.mode} Enumeration</PD.Heading>

                                {this.state.renderState == "error" &&
                                    <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                                }

                                <form> 
                                    <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                                    <PD.Editor label='Description' name="description" value={this.state.FormData.description} onChange={this.handleChange}/>

                                    <PD.Input label="Namespace" width="30" name="namespace" value={this.state.FormData.namespace} onChange={this.handleChange}/>
                                    <PD.Input label="Default Prefix" width="10" name="prefix" value={this.state.FormData.prefix} onChange={this.handleChange}/>

                                    <fieldset>
                                        <legend>Optional Structure for additional fields</legend>
                                        <SelectStructure label='Structure' name="idStructure" onChange={this.handleChange} selectDataDictionary={true} value={this.state.FormData.idStructure}/>
                                    </fieldset>
                                    <PD.Editor label='Notes' name="notes" value={this.state.FormData.notes} onChange={this.handleChange}/>
                                    <PD.Editor label='Proposals' name="proposals" value={this.state.FormData.proposals} onChange={this.handleChange}/>

                                    {this.FormTerms()}

                                    <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                                        {
                                            this.dsd.config.EnumerationStatuses.map(
                                                (status, posStatus) => 
                                                    {
                                                        return(
                                                            <option key={posStatus} value={status}>{status}</option>
                                                        )
                                                    }
                                            )
                                        }
                                    </PD.Select>
                                    
                                    {(() => {
                                        switch (this.state.renderState) {
                                            case "updating":
                                                return (
                                                    <div>
                                                        <PD.Button disabled={true} type="submit" name="btnSave">
                                                            <Buffering/>
                                                        </PD.Button>
                                                    </div>
                                                )
                                            default:
                                                return (
                                                    <div>
                                                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave" value="Save" />    
                                                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" /> 
                                                    </div>
                                                )
                                        }
                                    })()}

                                </form>

                            </div>    
                        );
                }
                break;
            case 'remove':
                return (
                    <div>
                        <PD.Heading>{this.state.mode} Enumeration</PD.Heading>

                        {this.state.isFailed &&
                            <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                        }

                        <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                        <ViewEnumeration Enumeration={this.state.Enumeration}/>

                    </div>
                )
            case 'view':
            default:
                
                switch (this.state.renderState){
                    case "loaded":
                        let countTerms = 0;
                        if (this.state.Enumeration){
                            if (this.state.Enumeration.Terms){
                                if (Array.isArray(this.state.Enumeration.Terms)){
                                    countTerms = this.state.Enumeration.Terms.length;
                                }
                            }
                        }
                        return (
                            <div>
                                <div>
                                    <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                    <PD.Heading>Enumeration:{this.state.Enumeration.name}</PD.Heading>
                                </div>

                                {this.state.OfferEdit &&
                                    <span style={{paddingRight:10}}>
                                            <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                    </span>
                                }

                                <ViewEnumeration Enumeration={this.state.Enumeration}/>

                                <br/>

                                <PD.Tabs>

                                    <div label={`Terms(${countTerms})`}>
                                        <PD.Table type='list'>
                                            <PD.Thead>
                                                <PD.Tr>
                                                    <PD.Th>Term</PD.Th>
                                                    <PD.Th>Description</PD.Th>
                                                </PD.Tr>
                                            </PD.Thead>
                                            <PD.Tbody>
                                                {
                                                    this.state.Enumeration.Terms.map(
                                                        (Term, pos) => 
                                                            {
                                                                return(
                                                                    <PD.Tr key={pos}>
                                                                        <PD.Td>
                                                                            {Term.term}
                                                                        </PD.Td>
                                                                        <PD.Td>
                                                                            <PD.MdPresent>
                                                                                {Term.description}
                                                                            </PD.MdPresent>
                                                                        </PD.Td>
                                                                    </PD.Tr>
                                                                )
                                                            }
                                                    )
                                                }
                                            </PD.Tbody>

                                        </PD.Table>
                                    </div>


                                    <div label='Data Dictionary'>
                                        <ViewDataDictionary DataDictionary={this.state.DataDictionary} />
                                    </div>

                                    <div label='Metadata'>
                                        <ViewMetadata Data={this.state.Enumeration} />
                                    </div>

                                    <div label='Developer'>
                                        <Rendition
                                            endpoint="/enumerations"
                                            id={this.state.idEnumeration}
                                        />
                                    </div>



                                </PD.Tabs>


                            </div>
                        )
                }
        };

        return <div />;
    };



    FormTerms(){

        let seqNext = 1;
        if (this.state.FormData.Terms){
            seqNext = this.state.FormData.Terms.length + 1;
        }
        return (
            <fieldset key={this.state.toggle}>
                <legend>Terms</legend>
                {this.state.FormData.Terms &&
                    this.state.FormData.Terms.map(
                        (Term, posTerm) => 
                        {
                            let seq = posTerm+1;
                            return(
                                this.FormTerm('edit', seq, Term)
                            )
                        }
                    )
                }
                {this.FormTerm('new', seqNext)}
            </fieldset>
        );

    }

    FormTerm(mode, seq, Term = {}){

        let onChange = function(event){

            const FormFieldName = event.target.name;
            let FormFieldValue = event.target.value;
            if (event.target.type == "checkbox"){
                FormFieldValue = event.target.checked;
            }

            let FormData = this.state.FormData;

            if (!('Terms' in FormData)){
                FormData['Terms'] = [];
            }
            let arrNew = []
            let selectedItem = null;
            for (let pos=0;pos<FormData.Terms.length;pos++){
                let item = FormData.Terms[pos];
                if (pos == (seq-1)){
                    selectedItem = item;
                }
                arrNew.push(item); 
            }
            if (!selectedItem){
                let selectedItem = {}
                arrNew.push(selectedItem);
            }

            if (selectedItem){
                selectedItem[FormFieldName] = FormFieldValue;
            }

    
            FormData.Terms = arrNew;
            this.setState({"FormData": FormData});

            return;
        }
        onChange = onChange.bind(this);

        let onAdd = function(event){

            let FormData = this.state.FormData;

            if (!('Terms' in FormData)){
                FormData['Terms'] = [];
            }
            if (!FormData.Terms){
                FormData['Terms'] = [];
            }
    
            FormData.Terms.push({});
            this.setState({"FormData": FormData});
    
            event.preventDefault();
            return;
        }
        onAdd = onAdd.bind(this);


        let onDelete = function(event){

            let FormData = {...this.state.FormData};
            FormData.Terms = [...(FormData.Terms || [])];
            FormData.Terms.splice(seq-1, 1);
            
            this.setState({"FormData": FormData,"toggle": !this.state.toggle});
    
            event.preventDefault();
            return;
        }
        onDelete = onDelete.bind(this);

        let onMoveUp = null;
        let onMoveDown = null;


        if (this.state.FormData.Terms){
            if (seq < this.state.FormData.Terms.length){
                onMoveDown = function(event){

                    let FormData = {...this.state.FormData};
                    FormData.Terms = [...(FormData.Terms || [])];
                    
                    // Swap with next item
                    [FormData.Terms[seq-1], FormData.Terms[seq]] =
                    [FormData.Terms[seq], FormData.Terms[seq-1]];
      
                    this.setState({"FormData": FormData, "toggle": !this.state.toggle});

                    event.preventDefault();
                    return;

                }
                onMoveDown = onMoveDown.bind(this);

            }


            if ((seq > 1) && (seq<=this.state.FormData.Terms.length)){
                onMoveUp = function(event){

                    let FormData = {...this.state.FormData};
                    FormData.Terms = [...(FormData.Terms || [])];
                    
                    // Swap with previous item
                    [FormData.Terms[seq-2], FormData.Terms[seq-1]] =
                    [FormData.Terms[seq-1], FormData.Terms[seq-2]];
                    
                    this.setState({"FormData": FormData});
                    this.setState({"FormData": FormData, "toggle": !this.state.toggle});

                    event.preventDefault();
                    return;
        
                }
                onMoveUp = onMoveUp.bind(this);
            }
        }

        return(

            <PD.Table type="list">
                <PD.Tbody>
                    <PD.Tr>
                        <PD.Td>
                            {(() => {
                                switch (mode) {
                                    case "new": 
                                        return <button name="btnAdd" onClick={onAdd}><Plus/></button>;
                                    case "edit": 
                                        return <button name="btnDelete" onClick={onDelete}><Trash/></button>;
                                }
                            })()}
                            {onMoveUp &&
                                <div>
                                    <button name="btnUp" onClick={onMoveUp}><ArrowUp/></button>
                                </div>
                            }
                            {onMoveDown &&
                                <div>
                                    <button name="btnDown" onClick={onMoveDown}><ArrowDown/></button>
                                </div>
                            }
                            
                        </PD.Td>
                        {mode == 'edit' &&
                            <React.Fragment>
                                <PD.Td>
                                    <PD.Input key={seq} label="Term" width="20" name="term" value={Term.term} onBlur={onChange}/>
                                </PD.Td>
                                <PD.Td>
                                    <PD.Editor label='Description' name="description" value={Term.description} onChange={onChange}/>
                                </PD.Td>

                            </React.Fragment>
                        }
                    </PD.Tr>
                </PD.Tbody>
            </PD.Table>
        )


    }

};

// Wrap and export
export default function Enumeration_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Enumeration {...props} navigation={navigation} location={location} params={params} />;
  }
